/**
 * `/pool` with no sub-path. This used to be a static `<Navigate to="/pool/dashboard" replace />`, which
 * stopped being correct on 30/7 when the dashboard became `_manage`-only (คุณใหม่: "role Viewer ไม่ให้
 * เห็น dashboard") — a pool-viewer clicking "Online Channel" in the nav would have been handed the
 * forbidden copy on their very first click, before seeing a single screen they're allowed to use.
 *
 * So: resolve the pool role FIRST, then send owner/admin to the dashboard (their landing screen is
 * unchanged) and everyone else to Accounts. Never redirect while the role is still unresolved — a guess
 * either way flashes a screen the user then gets bounced off. An access ERROR falls through to Accounts
 * rather than the dashboard: that screen asserts its own gate and renders the honest refusal, so a
 * failed access probe can never become a way into a `_manage` surface.
 */
import { Navigate } from "react-router-dom";
import { SkeletonRows } from "@/components/ui";
import { usePoolAccess } from "@/features/pool/hooks";

export function PoolIndexRedirect() {
  const accessQ = usePoolAccess();

  if (accessQ.isPending) return <SkeletonRows rows={3} />;

  const role = accessQ.data?.role ?? null;
  const canManage = role === "owner" || role === "admin";
  return <Navigate to={canManage ? "/pool/dashboard" : "/pool/accounts"} replace />;
}
